// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"3d9b6daa","239":"371bb206","453":"a9834b6b","455":"656a6e67","557":"80da37cb","762":"07d81d82"}[chunkId] + ".chunk.js";
};